import { Roles } from 'src/shared/enums';
import { RoleGuard } from '../shared/auth/guards/role.guard';
import { AuthGuard } from '../shared/auth/guards/auth.guard';

export const quotesPaths = {
	default: '',
	root: 'quotes',
	list: 'list',
	detail: ':id',
};

export const quotesFragments = {
	default: [quotesPaths.default],
	root: [quotesPaths.default, quotesPaths.root],
	list: [quotesPaths.default, quotesPaths.root, quotesPaths.list],
	detail: (id: number) => [quotesPaths.default, quotesPaths.root, id],
};

export const quotesDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const quotesDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: quotesDefaultAuthRoles },
};
